<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container fluid>

    <v-row dense no-gutters>
        <v-col cols="9">
            <v-text-field dense outlined height="43" v-model="comname" :label="$t('cfontdialog_label1')" disabled></v-text-field>
        </v-col>
        <v-col cols="3">
            <v-btn :disabled="disabled" class="ml-1 search_btn" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
        </v-col>
    </v-row>   
    <v-row>
      <v-dialog style="z-index: 9999;" persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" max-width="1000" >
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('cfontdialog_label2')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col md="10" sm="10" xs="10">
                  <v-text-field 
                    dense single-line clearable
                    @keyup.enter="search_run_com" 
                    v-model="search_keyword_com" 
                    :placeholder="$t('common_search_holder')"
                    outlined height="43"
                    color="#808080"
                    class="ml-10"
                    hide-details
                    />
                </v-col>
                <v-col md="2" sm="2" xs="2">
                  <v-btn class="search_btn" elevation="0" outlined large @click="search_run_com">{{$t("common_search")}}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-data-table
                    :headers="headers_com"
                    :items="itemList_com"
                    v-model="select_com"
                    :no-data-text="$t('common_nodata')"
                    hide-default-footer
                    class="datatablestyle ml-10 mr-10"
                    :items-per-page="9999"
                    item-key="IDX"
                    >
                    <template v-slot:header.NAME>
                      <label class="cheader_normal" >{{$t("cfontdialog_col1")}}</label>
                    </template>
                    <template v-slot:header.SAMPLE>
                      <label class="cheader_normal" >{{$t("cfontdialog_col2")}}</label>
                    </template>
                    <template v-slot:item.NAME="{ item }">
                      <a @click="save_com(item)">{{item.NAME}}</a>
                    </template>
                    <template v-slot:item.SAMPLE="{ item }">
                      <label :style="'font-size:20px; font-family:'+item.CODE">{{$t('cfontdialog_label3')}}</label>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn color="primary" @click="close_com">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            comname: String,
            comidx: Number,
            cbname:{type:String, default: "dev..."},
            disabled: {type:Boolean, default: false}
        },

        data: ()=> ({
            
            dialog_com : false,
            load_flag : false,

            headers_com: [
                {text: '폰트명',    value: 'NAME',  sortable: true, align:'center'},
                {text: '예시',      value: 'SAMPLE',  sortable: false, align:'left' }
            ],
            itemList_com: [],
            select_com:[],
            search_keyword_com : '',
        }),

        updated(){
          
          if(this.dialog_com){
            if(!this.load_flag && this.itemList_com.length == 0 && this.search_keyword_com.length == 0){
              this.load_flag = true;
              this.loadpage_com();
            }
          }else{
            this.load_flag = false;
          }

        },

        methods: {

            search_run_com(){
                this.loadpage_com();
            },

            loadpage_com(){

                this.$http.post(this.$host+'/api/DialogFontList',{
                  search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : escape(this.search_keyword_com)
                , sort_name: 'NAME'
                , sort_type: "DESC"
                , page: 1
                , pagerow: 99999
                , ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.comidx
                , LAN_CODE:this.$i18n.locale
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                    this.load_flag = true;
                    if(result.data.resultCode == 0){

                        //토큰 저장
                        if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                          this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                        }
                        if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                          this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                        }

                        const list = result.data.resultData;
                        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                        list.forEach(element => {
                            this.itemList_com.push(element); 
                        });

                    }else if(result.data.resultCode == 2){
                      //로그인 필요
                      this.$alert(this.$t("common_tokener"));
                      this.$session.clear("ADMIN_IDX");
                      this.$session.clear("COM_IDX");
                      this.$session.clear("ACNT_IDX");
                      this.$session.clear("GRADE");
                      this.$session.clear("COM_NAME");
                      this.$session.clear("ACCESSTOKEN");
                      this.$session.clear("REFLASHTOKEN");
                      this.$router.push('Login');   //로그인 페이지로 이동

                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    
                });

            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                this.search_keyword_com = '';
            },

            //추가 저장
            save_com(select_item){
              this.$emit('callback', select_item);
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
              this.select_com = [];
              this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
              this.search_keyword_com = '';
            },      

            showpopup_com(){
                this.dialog_com = true;
                this.load_flag = false;
            },


        }

    }
</script>

<style scoped>

</style>